import {useState, useRef} from 'react'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {toAbsoluteUrl} from '../../../../../_metronic/helpers'
import {useIntl} from 'react-intl'

export const ToolTipUIForModal = ({tooltipText}: {tooltipText?: string}) => {
  const [modalContainer, setModalContainer] = useState<HTMLElement | null>(null)
  const triggerRef = useRef<HTMLImageElement>(null)
  const {formatMessage} = useIntl()

  return (
    <span ref={(node) => setModalContainer(node)}>
      <OverlayTrigger
        placement='bottom'
        overlay={
          <Tooltip id='tooltip' className='ms-10'>
            <p className='m-0 '>
              {formatMessage({
                id: tooltipText,
              })}
            </p>
          </Tooltip>
        }
        container={modalContainer}
      >
        <img
          ref={triggerRef}
          src={toAbsoluteUrl('/media/icons/duotune/general/tooltip.svg')}
          alt='Tooltip'
          className='text-secondary ms-1'
          width='18px'
          height='18px'
        />
      </OverlayTrigger>
    </span>
  )
}
